import { PackagePickerType, RealEstateId } from '../../../src/enums';
import { DealerCreatives } from '../../../src/server/types/dealer';
import { PRODUCT_GUIDS } from '../dynamicOfferingMocks/dynamo-products-mock';
import { mockDealerOffering } from './mockOffering';
import { MocksByPackagePickerType } from './utils';

export const mockSunriseOfferingCardsMarketingItems = {
  [PRODUCT_GUIDS.SUNRISE_V2_LIGHT]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'premium-purchase-plan.cards.feature.site_contributors.light',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'premium-purchase-plan.cards.feature.marketing_suite.light',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        iconImg: '', // TODO: add based on the offer when it will be live
        iconPosition: 'suffix',
        translationKey: 'premium-purchase-plan.cards.feature.free_domain',
      },
      fourthLineItem: {
        isActive: false,
      },
      fifthLineItem: {
        isActive: false,
      },
      sixthLineItem: {
        isActive: false,
      },
      seventhLineItem: {
        isActive: false,
      },
      eighthLineItem: {
        isActive: false,
      },
    }),
  [PRODUCT_GUIDS.SUNRISE_V2_CORE]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'premium-purchase-plan.cards.feature.site_contributors.core',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'premium-purchase-plan.cards.feature.marketing_suite.core',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        iconImg:
          'https://wixmp-70a14ff54af6225c7974eec7.wixmp.com/offers-assets/c7c3d697-5a5c-487b-bf9e-1746bf563906.svg',
        iconPosition: 'suffix',
        translationKey: 'premium-purchase-plan.cards.feature.free_domain',
      },
      fourthLineItem: {
        isActive: true,
        order: 4,
        translationKey:
          'premium-purchase-plan.cards.feature.site_analytics.basic',
      },
      fifthLineItem: {
        isActive: true,
        order: 5,
        translationKey: 'premium-purchase-plan.cards.feature.accept_payments',
      },
      sixthLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'premium-purchase-plan.cards.feature.processing_fees.low',
      },
      seventhLineItem: {
        isActive: true,
        order: 6,
        translationKey: 'premium-purchase-plan.cards.feature.ecommerce.basic',
      },
      eighthLineItem: {
        isActive: false,
      },
    }),
  [PRODUCT_GUIDS.SUNRISE_V2_BUSINESS]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'premium-purchase-plan.cards.feature.site_contributors.business',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'premium-purchase-plan.cards.feature.marketing_suite.business',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        iconImg:
          'https://wixmp-70a14ff54af6225c7974eec7.wixmp.com/offers-assets/c7c3d697-5a5c-487b-bf9e-1746bf563906.svg',
        iconPosition: 'suffix',
        translationKey: 'premium-purchase-plan.cards.feature.free_domain',
      },
      fourthLineItem: {
        isActive: true,
        order: 4,
        translationKey:
          'premium-purchase-plan.cards.feature.site_analytics.standard',
      },
      fifthLineItem: {
        isActive: true,
        order: 5,
        translationKey: 'premium-purchase-plan.cards.feature.accept_payments',
      },
      sixthLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'premium-purchase-plan.cards.feature.processing_fees.mid',
      },
      seventhLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'premium-purchase-plan.cards.feature.ecommerce.standard',
      },
      eighthLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'premium-purchase-plan.cards.feature.developer_tools.standard',
      },
    }),
  [PRODUCT_GUIDS.SUNRISE_V2_BUSINESS_ELITE]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'premium-purchase-plan.cards.feature.site_contributors.business_elite',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'premium-purchase-plan.cards.feature.marketing_suite.business_elite',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        iconImg:
          'https://wixmp-70a14ff54af6225c7974eec7.wixmp.com/offers-assets/c7c3d697-5a5c-487b-bf9e-1746bf563906.svg',
        iconPosition: 'suffix',
        translationKey: 'premium-purchase-plan.cards.feature.free_domain',
      },
      fourthLineItem: {
        isActive: true,
        order: 4,
        translationKey:
          'premium-purchase-plan.cards.feature.site_analytics.advanced',
      },
      fifthLineItem: {
        isActive: true,
        order: 5,
        translationKey: 'premium-purchase-plan.cards.feature.accept_payments',
      },
      sixthLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'premium-purchase-plan.cards.feature.processing_fees.high',
      },
      seventhLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'premium-purchase-plan.cards.feature.ecommerce.advanced',
      },
      eighthLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'premium-purchase-plan.cards.feature.developer_tools.advanced',
      },
    }),
  [PRODUCT_GUIDS.SUNRISE_V2_ENTERPRISE]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'premium-purchase-plan.cards.enterprise.all_premium_plus',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'premium-purchase-plan.cards.enterprise_feature.unlimited_site_contributors',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        translationKey:
          'premium-purchase-plan.cards.enterprise_feature.multi-site_management',
      },
      fourthLineItem: {
        isActive: true,
        order: 4,
        translationKey:
          'premium-purchase-plan.cards.enterprise_feature.single-sign_on',
      },
      fifthLineItem: {
        isActive: true,
        order: 5,
        translationKey:
          'premium-purchase-plan.cards.enterprise_feature.dedicated_account_manager',
      },
      sixthLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'premium-purchase-plan.cards.enterprise_feature.centralized_billing',
      },
      seventhLineItem: {
        isActive: true,
        order: 7,
        translationKey:
          'premium-purchase-plan.cards.enterprise_feature.custom_templates',
      },
      eighthLineItem: {
        isActive: true,
        order: 8,
        translationKey:
          'premium-purchase-plan.cards.enterprise_feature.custom_integrations',
      },
    }),
};

export const mockStudioOfferingCardsMarketingItems = {
  [PRODUCT_GUIDS.WIX_STUDIO_V1_BASIC]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'studio_package_picker.cards.feature.storage_space.basic',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'studio_package_picker.cards.feature.site_contributors.basic',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        translationKey: 'studio_package_picker.cards.feature.cms.basic',
      },
      fourthLineItem: {
        isActive: true,
        order: 4,
        translationKey:
          'studio_package_picker.cards.feature.site_analytics.basic',
      },
      fifthLineItem: {
        isActive: false,
      },
      sixthLineItem: {
        isActive: false,
      },
      seventhLineItem: {
        isActive: false,
      },
      eighthLineItem: {
        isActive: false,
      },
    }),
  [PRODUCT_GUIDS.WIX_STUDIO_V1_STANDARD]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'studio_package_picker.cards.feature.storage_space.standard',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'studio_package_picker.cards.feature.site_contributors.standard',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        translationKey: 'studio_package_picker.cards.feature.cms.standard',
      },
      fourthLineItem: {
        isActive: true,
        order: 4,
        translationKey:
          'studio_package_picker.cards.feature.site_analytics.standard',
      },
      fifthLineItem: {
        isActive: true,
        order: 5,
        translationKey:
          'studio_package_picker.cards.feature.accept_payments.standard',
      },
      sixthLineItem: {
        isActive: false,
      },
      seventhLineItem: {
        isActive: false,
      },
      eighthLineItem: {
        isActive: false,
      },
    }),
  [PRODUCT_GUIDS.WIX_STUDIO_V1_PLUS]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'studio_package_picker.cards.feature.storage_space.plus',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'studio_package_picker.cards.feature.site_contributors.plus',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        translationKey: 'studio_package_picker.cards.feature.cms.plus',
      },
      fourthLineItem: {
        isActive: true,
        order: 4,
        translationKey:
          'studio_package_picker.cards.feature.site_analytics.plus',
      },
      fifthLineItem: {
        isActive: true,
        order: 5,
        translationKey:
          'studio_package_picker.cards.feature.accept_payments.plus',
      },
      sixthLineItem: {
        isActive: false,
      },
      seventhLineItem: {
        isActive: false,
      },
      eighthLineItem: {
        isActive: false,
      },
    }),
  [PRODUCT_GUIDS.WIX_STUDIO_V1_ELITE]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'studio_package_picker.cards.feature.storage_space.elite',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'studio_package_picker.cards.feature.site_contributors.elite',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        translationKey: 'studio_package_picker.cards.feature.cms.elite',
      },
      fourthLineItem: {
        isActive: true,
        order: 4,
        translationKey:
          'studio_package_picker.cards.feature.site_analytics.elite',
      },
      fifthLineItem: {
        isActive: true,
        order: 5,
        translationKey:
          'studio_package_picker.cards.feature.site_analytics.elite',
      },
      sixthLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'studio_package_picker.cards.feature.accept_payments.elite',
      },
      seventhLineItem: {
        isActive: true,
        order: 7,
        translationKey: 'studio_package_picker.cards.data_infra.elite',
      },
      eighthLineItem: {
        isActive: false,
        order: 8,
      },
    }),
  [PRODUCT_GUIDS.WIX_STUDIO_V1_ENTERPRISE]:
    mockDealerOffering<DealerCreatives.MarketingCards>({
      firstLineItem: {
        isActive: true,
        order: 1,
        translationKey:
          'studio_package_picker.cards.enterprise.all_studio_plus',
      },
      secondLineItem: {
        isActive: true,
        order: 2,
        translationKey:
          'studio_package_picker.cards.enterprise_feature.unlimited_site_contributors',
      },
      thirdLineItem: {
        isActive: true,
        order: 3,
        translationKey: 'studio_package_picker.cards.enterprise_feature.cms',
      },
      fourthLineItem: {
        isActive: true,
        order: 4,
        translationKey:
          'premium-purchase-plan.cards.enterprise_feature.multi-site_management',
      },
      fifthLineItem: {
        isActive: true,
        order: 5,
        translationKey:
          'studio_package_picker.cards.enterprise_feature.single-sign_on',
      },
      sixthLineItem: {
        isActive: true,
        order: 6,
        translationKey:
          'studio_package_picker.cards.enterprise_feature.centralized_billing',
      },
      seventhLineItem: {
        isActive: true,
        order: 7,
        translationKey:
          'studio_package_picker.cards.enterprise_feature.custom_integrations',
      },
      eighthLineItem: {
        isActive: true,
        order: 8,
        translationKey:
          'studio_package_picker.cards.enterprise_feature.custom_ssl',
      },
      ninthLineItem: {
        isActive: true,
        order: 9,
        translationKey:
          'studio_package_picker.cards.enterprise_feature.dedicated_account_manager',
      },
    }),
};

export const mockOfferingCardsMarketingItems = {
  ...mockStudioOfferingCardsMarketingItems,
  ...mockSunriseOfferingCardsMarketingItems,
};

export const mockAllPlansIncludeItems =
  mockDealerOffering<DealerCreatives.AllPlansInclude>({
    eighthItem: {
      featureTitleTranslationKey:
        'studio_package_picker.banner.all_plans_include.full_dns_management',
      order: 8,
    },
    fifthItem: {
      featureTitleTranslationKey:
        'studio_package_picker.banner.all_plans_include.advanced_seo',
      order: 5,
    },
    firstItem: {
      featureTitleTranslationKey:
        'studio_package_picker.banner.all_plans_include.custom_domain',
      order: 1,
    },
    fourthItem: {
      featureTitleTranslationKey:
        'studio_package_picker.banner.all_plans_include.unlimited_bandwidth',
      order: 4,
    },
    secondItem: {
      featureTitleTranslationKey:
        'studio_package_picker.banner.all_plans_include.free_domain',
      order: 2,
    },
    seventhItem: {
      featureTitleTranslationKey:
        'studio_package_picker.banner.all_plans_include.support',
      order: 7,
    },
    sixthItem: {
      featureTitleTranslationKey:
        'studio_package_picker.banner.all_plans_include.marketing_automation_tools',
      order: 6,
    },
    thirdItem: {
      featureTitleTranslationKey:
        'studio_package_picker.banner.all_plans_include.no_branding',
      order: 3,
    },
  });

export const mockShowCaseItems =
  mockDealerOffering<DealerCreatives.StudioShowcaseItems>({
    firstItem: {
      iconImg:
        'https://wixmp-70a14ff54af6225c7974eec7.wixmp.com/offers-assets/f418ae7d-a3c9-4a58-932e-2a852fec0551.svg',
      titleTranslationKey:
        'studio_package_picker.header.studio_benefits.AI_responsive',
      order: 1,
    },
    secondItem: {
      iconImg:
        'https://wixmp-70a14ff54af6225c7974eec7.wixmp.com/offers-assets/641a46d6-ccef-4f5e-a8ea-d2ad3f58b0f9.svg',
      titleTranslationKey:
        'studio_package_picker.header.studio_benefits.collaborative_workspace',
      order: 2,
    },
    thirdItem: {
      iconImg:
        'https://wixmp-70a14ff54af6225c7974eec7.wixmp.com/offers-assets/d1c90551-62f1-4b99-942f-908be05236e2.svg',
      titleTranslationKey:
        'studio_package_picker.header.studio_benefits.advanced_code_IDE',
      order: 3,
    },
  });

export const AppIntentMocks: MocksByPackagePickerType = {
  [PackagePickerType.Sunrise]: mockDealerOffering<DealerCreatives.AppIntent>({
    website: 'mock-sunrise-website-title',
    business: 'premium-purchase-plan.header.default.title',
    enterprise: 'mock-sunrise-enterprise-title',
    landingTab: 'mock-sunrise-landing-tab',
    recommendedSection: 'mock-sunrise-recommended-section',
    intent: 'mock-sunrise-intent',
  }),
  [PackagePickerType.Studio]: mockDealerOffering<DealerCreatives.AppIntent>({
    website: 'mock-studio-website-title',
    business: 'mock-studio-business-title',
    enterprise: 'mock-studio-enterprise-title',
    landingTab: 'mock-studio-landing-tab',
    recommendedSection: 'mock-studio-recommended-section',
    intent: 'mock-studio-intent',
  }),
  [PackagePickerType.EditorXToStudio]:
    mockDealerOffering<DealerCreatives.AppIntent>({
      website: 'mock-studio-website-title',
      business: 'mock-studio-business-title',
      enterprise: 'mock-studio-enterprise-title',
      landingTab: 'mock-studio-landing-tab',
      recommendedSection: 'mock-studio-recommended-section',
      intent: 'mock-studio-intent',
    }),
  [PackagePickerType.Default]: mockDealerOffering<DealerCreatives.AppIntent>({
    website: 'mock-default-website-title',
    business: 'mock-default-business-title',
    enterprise: 'mock-default-enterprise-title',
    landingTab: 'mock-default-landing-tab',
    recommendedSection: 'mock-default-recommended-section',
    intent: 'mock-default-intent',
  }),
  [PackagePickerType.EditorX]: mockDealerOffering<DealerCreatives.AppIntent>({
    website: 'mock-editorx-website-title',
    business: 'mock-editorx-business-title',
    enterprise: 'mock-editorx-enterprise-title',
    landingTab: 'mock-editorx-landing-tab',
    recommendedSection: 'mock-editorx-recommended-section',
    intent: 'mock-editorx-intent',
  }),
};

export const RecommendedProductFamilyMocks: MocksByPackagePickerType = {
  [PackagePickerType.Sunrise]:
    mockDealerOffering<DealerCreatives.RecommendedProductFamily>({
      productFamilies: 'Business',
      text: 'Best value!',
    }),
  [PackagePickerType.Studio]:
    mockDealerOffering<DealerCreatives.RecommendedProductFamily>({
      productFamilies: 'Core',
      text: 'For you',
    }),
  [PackagePickerType.EditorXToStudio]:
    mockDealerOffering<DealerCreatives.RecommendedProductFamily>({
      productFamilies: 'Core',
      text: 'For you',
    }),
  [PackagePickerType.Dayful]:
    mockDealerOffering<DealerCreatives.RecommendedProductFamily>({
      productFamilies: '',
      text: 'For you',
    }),
};

export const FaqsMocks: MocksByPackagePickerType = {
  [PackagePickerType.Sunrise]: mockDealerOffering<DealerCreatives.Faq>({
    contentType: 'key',
    title: { content: 'mock-sunrise-faq-title' },
    subtitle: {
      content: 'mock-sunrise-faq-subtitle',
      params: {
        firstParam: { linkUrl: { url: 'mock-sunrise-faq-subtitle-link' } },
      },
    },
    firstFaqItem: {
      question: { content: 'mock-sunrise-faq-question-1' },
      answer: { content: 'mock-sunrise-faq-answer-1', params: {} },
      isOpen: false,
      isActive: true,
      order: 1,
    },
    secondFaqItem: {
      question: { content: 'mock-sunrise-faq-question-2' },
      answer: { content: 'mock-sunrise-faq-answer-2', params: {} },
      isOpen: false,
      isActive: true,
      order: 2,
    },
  }),
  [PackagePickerType.Studio]: mockDealerOffering<DealerCreatives.Faq>({
    contentType: 'key',
    title: { content: 'mock-studio-faq-title' },
    subtitle: {
      content: 'mock-studio-faq-subtitle',
      params: {
        firstParam: { linkUrl: { url: 'mock-studio-faq-subtitle-link' } },
      },
    },
    firstFaqItem: {
      question: { content: 'mock-studio-faq-question-1' },
      answer: { content: 'mock-studio-faq-answer-1', params: {} },
      isOpen: false,
      isActive: true,
      order: 1,
    },
    secondFaqItem: {
      question: { content: 'mock-studio-faq-question-2' },
      answer: { content: 'mock-studio-faq-answer-2', params: {} },
      isOpen: false,
      isActive: true,
      order: 2,
    },
  }),
};

export const mockAcceptedPaymentMethods =
  mockDealerOffering<DealerCreatives.AcceptedPaymentMethods>({
    paymentMethods: 'visa,amex,diners',
  });

export const DealerMocksByRealestateIds = {
  [RealEstateId.WixStudioAllPlansInclude]: mockAllPlansIncludeItems,
  [RealEstateId.WixStudioShowCaseItems]: mockShowCaseItems,
  [RealEstateId.WixStudioMarketingCards]: mockStudioOfferingCardsMarketingItems,
  [RealEstateId.AcceptPaymentMethods]: mockAcceptedPaymentMethods,
};

export const StudioAllPlansIncludeMock: MocksByPackagePickerType = {
  [PackagePickerType.Studio]:
    mockDealerOffering<DealerCreatives.AllPlansInclude>({
      firstItem: {
        featureTitleTranslationKey: 'promotional-feature-2',
        order: 2,
      },
      secondItem: {
        featureTitleTranslationKey: 'promotional-feature-3',
        order: 3,
      },
      thirdItem: {},
      fourthItem: {
        order: 1,
        featureTitleTranslationKey: 'promotional-feature-1',
      },
      fifthItem: {
        featureTitleTranslationKey: 'inactive-feature',
      },
    }),
};

export const StudioShowcaseItemsMock: MocksByPackagePickerType = {
  [PackagePickerType.Studio]:
    mockDealerOffering<DealerCreatives.StudioShowcaseItems>({
      firstItem: {
        titleTranslationKey: 'promotional-feature-2',
        order: 2,
      },
      secondItem: {
        titleTranslationKey: 'promotional-feature-3',
        order: 3,
      },
      thirdItem: {},
      fourthItem: {
        order: 1,
        titleTranslationKey: 'promotional-feature-1',
      },
      fifthItem: {
        titleTranslationKey: 'inactive-feature',
      },
    }),
};
